module.exports = __webpack_public_path__ + "img/icon-warning-snø-3.025558e2.svg";